var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-groupcard',{attrs:{"carddata":_vm.carddata,"headersdata":_vm.headersdata,"dropdowns":_vm.dropdowns}})}
var staticRenderFns = []

export { render, staticRenderFns }